// showAlert.js
import Swal from "sweetalert2";
import "./swalPopupWithButtons.css";

const ShowSwalWithButtons = (title, text, icon, darkMode, onConfirm) => {
  const destructive = /\b(delete|remove|discard)\b/i.test(`${title} ${text}`);
  const destructiveLabel = /\bremove\b/i.test(`${title} ${text}`)
    ? "Remove"
    : /\bdiscard\b/i.test(`${title} ${text}`)
    ? "Discard"
    : "Delete";

  Swal.fire({
    title: title,
    html: text,
    icon: destructive ? "warning" : icon,
    iconHtml: destructive
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 2.5 20h19L12 3Z"/><path d="M12 9v4m0 3h.01"/></svg>'
      : undefined,
    showCancelButton: true,
    showCloseButton: destructive,
    confirmButtonColor: "#4CAF50",
    cancelButtonColor: "#6c757d",
    confirmButtonText: destructive ? destructiveLabel : "Yes",
    cancelButtonText: destructive ? "Cancel" : "No",
    buttonsStyling: !destructive,
    allowEnterKey: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    reverseButtons: true,
    customClass: {
      container: destructive ? "app-delete-swal-container" : undefined,
      title: destructive
        ? "app-delete-swal-title"
        : darkMode
        ? "swal-title-dark"
        : "swal-title-light",
      popup: destructive
        ? `app-delete-swal${darkMode ? " dark" : ""}`
        : darkMode
        ? "darkPopup"
        : "whitePopup",
      icon: destructive ? "app-delete-swal-icon" : undefined,
      htmlContainer: destructive ? "app-delete-swal-body" : undefined,
      actions: destructive ? "app-delete-swal-actions" : undefined,
      cancelButton: destructive ? "app-delete-swal-cancel" : undefined,
      confirmButton: destructive ? "app-delete-swal-confirm" : undefined,
      closeButton: destructive ? "app-delete-swal-close" : undefined,
    },
  }).then((result) => {
    if (result.isConfirmed && onConfirm) {
      onConfirm();
    }
  });
};

export default ShowSwalWithButtons;
